import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaDireccion } from '../_direccion.js';

/**
 * Los socios y su capital, dentro del grupo `_direccion`.
 *
 * VA EN DIRECCIÓN Y NO EN CONTABILIDAD, aunque la contadora SÍ puede leer las dos vistas: son de
 * nivel 3 y su rol lo alcanza. La ruta la decide la acción de la pantalla, no la lectura: registrar
 * un aporte o un retiro es `socios.registrar`, que en la matriz es del administrador solo, y esa es
 * la razón por la que existe esta pantalla. Partirla en dos rutas, una de lectura en contabilidad y
 * otra de escritura en dirección, dejaría dos pantallas que muestran la misma tabla.
 *
 * Si algún día la contadora necesita el historial para cerrar el mes, se resuelve dándole la lectura
 * desde el estado de resultados, que es donde ella trabaja, y no duplicando esta pantalla.
 */
export const rutaSocios = createRoute({
  getParentRoute: () => rutaDireccion,
  path: '/socios',
  component: lazyRouteComponent(() => import('./socios-pantalla.js'), 'RutaSocios'),
});
